// Libraries
import { Flex, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
// Components
import { RatingsIcon } from '@atoms/index';
// Utils
import { formatNumberToDecimal } from '@helpers/index';
import { colors } from '@themeFoundations/colors';
// Types
import { RatingLabeledProps, SizeStyles } from './RatingLabeled.type';
import { Sizes } from '@globalTypes/index';

const sizeStyles: SizeStyles = {
  md: {
    prepended: false,
    paddingXAxis: 3,
    fontSize: 'sm',
    height: 5,
    boxSize: 5,
    variant: 'faded',
  },
  sm: {
    prepended: true,
    paddingXAxis: 2,
    fontSize: 'sm',
    height: 5,
    boxSize: 5,
  },
  lg: {
    prepended: false,
    paddingXAxis: 3,
    fontSize: 'md',
    height: 6,
    boxSize: 6,
    variant: 'faded',
  },
};

/**
 * RatingLabeled component.
 *
 * @component
 * @param {RatingLabeledProps} props - The props for the RatingLabeled component.
 * @param {RatingCategory} props.rating - The rating value.
 * @param {number} props.score - The score value.
 * @returns {ReactElement} The rendered RatingLabeled component.
 */
export const RatingLabeled = ({ rating, score, size = Sizes.sm }: RatingLabeledProps): ReactElement => {
  const { prepended, paddingXAxis, fontSize, height, boxSize, variant } = sizeStyles[size] ?? {};

  return (
    <Flex h='min-content'>
      <RatingsIcon rating={rating} prepended={prepended} dark boxSize={boxSize} zIndex={1} />
      <Flex
        borderStyle='solid'
        borderColor={colors.ratings[rating].dark}
        borderWidth='1px'
        borderRightRadius='base'
        px={paddingXAxis}
        h={height}
        pl={4}
        ml='-2'
      >
        <Text variant={variant} fontSize={fontSize} alignSelf='center'>
          {score !== null ? formatNumberToDecimal(score, 2) : 'N/A'}
        </Text>
      </Flex>
    </Flex>
  );
};
